import * as Sentry from '@sentry/react'
// eslint-disable-next-line no-restricted-imports
import queryString from 'query-string'
import React, { FC } from 'react'
import { hydrate, render as reactDomRender } from 'react-dom'

import { routeMap } from '~redux/routes'

import App from '../shared/App'
import createStore from '../shared/redux/store'
import AllTheProviders from './AllTheProviders'
import { PrerequisiteLoader } from './PrerequisiteLoader'

declare global {
  interface Window {
    SENTRY_RELEASE: { id: string }
    __PRELOADED_STATE__: {}
  }

  export interface NodeModule {
    hot?: {
      accept: (path: string, cb: Function) => void
    }
  }
}

const { store } = createStore(
  window.__PRELOADED_STATE__,
  {
    querySerializer: queryString,
  },
  routeMap,
)
store.dispatch({ type: 'CLIENT_LOAD' })

if (process.env.NODE_ENV === 'production') {
  try {
    const { environment, sentryDSN: dsn } = store.getState()['config']
    Sentry.init({
      dsn,
      environment,
      // SentryWebpackPlugin sets the sentry release, it is important that they match
      release: `clientui${
        process.env.PROJECT_BRANCH ? `-${process.env.PROJECT_BRANCH}` : ''
      }`,
    })
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Sentry was unable to initialize', e)
  }
}

const render = (App: FC) => {
  // Fixes: Expected server HTML to contain a matching * in *
  const renderMethod = module.hot ? reactDomRender : hydrate

  renderMethod(
    <AllTheProviders store={store}>
      <PrerequisiteLoader>
        <App />
      </PrerequisiteLoader>
    </AllTheProviders>,
    document.getElementById('react-root'),
  )
}

render(App)
/**
 * This script provides hot module reloading in development mode.
 */
if (module.hot && process.env.NODE_ENV === 'development') {
  module.hot.accept('../shared/App', () => {
    const App = require('../shared/App').default
    render(App)
  })
}
